<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div [hidden]="isLoading" data-automation="public-phone-pin-reset">
  <ziro-pin-reset #vmPin [fieldId]="'vmPinReset'" (resetClicked)="onSubmit()"></ziro-pin-reset>
</div>
